import Button from "components/Form/Button"
import InputNew from "components/Form/InputNew"
import { useResetPasswordContext } from "context/ResetPasswordContext"
import { useLang } from "hooks/useLang"
import Link from "next/link"

const ResetPasswordEmail = () => {
    const { t } = useLang()
    const { onChange, requestOTP, isRequestLoading, form, errorForm } =
        useResetPasswordContext()

    return (
        <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-2 text-center">
                <h1 className="text-center text-2xl font-bold md:text-3xl">
                    {t("reset_pass")}
                </h1>
                <p className="text-sm md:text-base">{t("reset_pass_text")}</p>
            </div>

            <form
                onSubmit={requestOTP}
                className="flex flex-col gap-4 md:gap-5">
                <InputNew
                    label={t("lb_email")}
                    inputID={"email_reset_password"}
                    name={"email"}
                    type={"text"}
                    onChange={(e) => onChange("email", e.target.value)}
                    value={form.email}
                    error={errorForm?.email}
                />

                <Button
                    text={t("btn_reset")}
                    loading={isRequestLoading}
                    disabled={form.email === ""}
                    type="submit"
                    className="p-2"
                />

                <div className="flex items-center justify-center gap-2">
                    <p className="text-xs text-gray-600 dark:text-gray-200 md:text-sm">
                        {t("dont_have_account")}
                    </p>
                    <Link
                        href="/user/signup"
                        passHref
                        className="text-link">
                        {t("btn_signup")}
                    </Link>
                </div>
            </form>
        </div>
    )
}

export default ResetPasswordEmail
